export class NavigationDropdown {
    ESC_keyCode = 27;

    // staff
    win = $(window);
    dropdown;

    constructor() {
        this.init();
    }

    init() {
        this.dropdown = $('.navigation-dropdown');

        if (!this.dropdown.length) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.win.on('keyup', (e) => this.onESCKeyup(e));
        this.dropdown.on('click', 'a[href^="#navigation-dropdown__submenu"]', (e) => this.toggleDropdown(e));
    }

    toggleDropdown(e) {
        e.preventDefault();

        const ul = $(e.currentTarget)[0].hash;
        $(ul).toggleClass('navigation-dropdown__submenu--active');
    }

    onESCKeyup(e) {
        e.preventDefault();

        if (e.keyCode !== this.ESC_keyCode) {
            return;
        }

        this.closeDropdown();
    }

    // auxiliary
    closeDropdown() {
        this.dropdown.find('.navigation-dropdown__submenu').removeClass('navigation-dropdown__submenu--active')
    }
}
